import { useState, useRef } from "react";
import axios from "axios";
// import { useNavigate } from "react-router-dom";
import { ReactSVG } from "react-svg";

// Images
import exclamationMark from "../assets/images/circle-exclamation-solid.svg";
import exclamationMark2 from "../assets/images/exclamation.svg";
import like from "../assets/images/like.svg";
import loadingIcon from "../assets/images/loading.svg";

const NAME_MIN_LENGTH = 2;
const NAME_MAX_LENGTH = 100;
const MESSAGE_MIN_LENGTH = 5;
const MESSAGE_MAX_LENGTH = 2000;
const EMAIL_MAX_LENGTH = 254;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function validateName(value) {
  const trimmed = value.trim();
  if (!trimmed) return 'Vyplňte Vaše jméno';
  if (trimmed.length < NAME_MIN_LENGTH) return 'Jméno je příliš krátké';
  if (trimmed.length > NAME_MAX_LENGTH) return 'Jméno je příliš dlouhé';
  return '';
}

function validateEmail(value) {
  const trimmed = value.trim();
  if (!trimmed) return 'Vyplňte Váš e-mail';
  if (!EMAIL_REGEX.test(trimmed)) return 'Zadejte prosím platnou e-mailovou adresu';
  if (trimmed.length > EMAIL_MAX_LENGTH) return 'E-mail je příliš dlouhý';
  return '';
}

function validateMessage(value) {
  const trimmed = value.trim();
  if (!trimmed) return 'Napište Váš dotaz';
  if (trimmed.length < MESSAGE_MIN_LENGTH) return 'Zpráva je příliš krátká';
  if (trimmed.length > MESSAGE_MAX_LENGTH) return 'Zpráva je příliš dlouhá (max. 2000 znaků)';
  return '';
}

export default function Form(prop){
    const { successHeading, successParagraph, failureHeading, failureParaghraph } = prop;

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [nameError, setNameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [messageError, setMessageError] = useState('');
    const [popupView, setPopupView] = useState(false);
    const [isSend, setIsSend] = useState(false);
    const [loading, setLoading] = useState(true);
    const [website, setWebsite] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const formRenderedAt = useRef(Date.now());

    // const navigate = useNavigate();
  
    const handleSubmit = (e) => {
      e.preventDefault();

      const nameValidationError = validateName(name);
      const emailValidationError = validateEmail(email);
      const messageValidationError = validateMessage(message);

      setNameError(nameValidationError);
      setEmailError(emailValidationError);
      setMessageError(messageValidationError);

      if(!nameValidationError && !emailValidationError && !messageValidationError){
        const trimmedName = name.trim();
        const trimmedEmail = email.trim();
        const trimmedMessage = message.trim();

        setPopupView(true);
        document.querySelector('body').classList.add("frozen");

        axios.post(`${process.env.REACT_APP_BACKEND_API}/sendemail`, {email: trimmedEmail, name: trimmedName, message: trimmedMessage, website, formRenderedAt: formRenderedAt.current}, {headers: {'access-key': process.env.REACT_APP_ACCESS_KEY}})
        .then((res) => {
          setLoading(false);
          setIsSend(true);
          setName('');
          setEmail('');
          setMessage('');
          document.querySelector("#vase-jmeno").value = "";
          document.querySelector("#vas-email").value = "";
          document.querySelector("#vase-zprava").value = "";
        })
        .catch((err) => {
          setLoading(false);
          setIsSend(false);
          setErrorMessage(err.response?.data?.message || '');
        })
      }
    }

    const closePopup = () => {
      setPopupView(false); 
      document.querySelector('body').classList.remove("frozen"); 
    }

    const disableFuncition = () => {}

    return(
      <>
        <form onSubmit={handleSubmit}>
          <div className="input-wrapper">
            <div className="input-content">
              <label htmlFor="vase-jmeno">Vaše jméno</label>
              <input type="text" id="vase-jmeno" name="vase-jmeno" placeholder=" " onChange={(e) => { setName(e.target.value); setNameError(validateName(e.target.value)); }} />
              <div className="form-message">{nameError ? <ReactSVG src={exclamationMark} /> : null}{nameError}</div>
            </div>
          </div>
          <div className="input-wrapper">
            <div className="input-content">
              <label htmlFor="vas-email">Váš e-mail</label>
              <input type="email" id="vas-email" name="vas-email" placeholder=" " onChange={(e) => { setEmail(e.target.value); setEmailError(validateEmail(e.target.value)); }} />
              <div className="form-message">{emailError ? <ReactSVG src={exclamationMark} /> : null}{emailError}</div>
            </div>
          </div>
          <div className="input-wrapper">
            <div className="input-content">
              <label htmlFor="vase-zprava">Vaše zpráva</label>
              <textarea id="vase-zprava" name="vase-zprava" placeholder=" " onChange={(e) => { setMessage(e.target.value); setMessageError(validateMessage(e.target.value)); }} rows="5"></textarea>
              <div className="form-message">{messageError ? <ReactSVG src={exclamationMark} /> : null}{messageError}</div>
            </div>
          </div>
          <div className="input-wrapper" style={{ position: 'absolute', left: '-9999px', top: '-9999px' }} aria-hidden="true">
            <div className="input-content">
              <label htmlFor="website">Web</label>
              <input type="text" id="website" name="website" tabIndex="-1" autoComplete="off" value={website} onChange={(e) => setWebsite(e.target.value)} />
            </div>
          </div>
          <input type="submit" value="Odeslat zprávu" className="button-fill-light" />
        </form>
        <div id={isSend ? 'success-message' : 'popup'} className={popupView ? 'popup show' : 'popup'} onClick={loading ? disableFuncition : closePopup}>
          <div className="popup-box">
            <div className="popup-icon">
              {loading ? <ReactSVG src={loadingIcon} /> : isSend ? <ReactSVG src={like} /> : <ReactSVG src={exclamationMark2} /> }
            </div>
            <div className="popup-message">
              <h4>{loading ? "Odesílání zpávy..." : isSend ? successHeading : failureHeading}</h4>
              <p>{loading ? "Prosím vyčkejte vteřinku" : isSend ? successParagraph : (errorMessage || failureParaghraph)}</p>
              <button className={loading ? "button-nofill-light none" : "button-nofill-light"} onClick={loading ? disableFuncition : closePopup}>Zavřít</button>
            </div>
          </div>
        </div>
      </>
    )
}